import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Projects } from "../projects/projects.entity";
import { UserEntity } from "../user/user.entity";
@Entity('states')
export class States {

  @PrimaryGeneratedColumn("increment",{name:'state_id'})
  stateId:number;
  @Column("char",{
      nullable:false,
      length:5,
      name:"state_code"
      })
  @Index({unique:true})
  stateCode:string;
  @Column("varchar",{
      nullable:false,
      length:50,
      name:"state_name"
      })
  stateName:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"status"
    })
  status:boolean;
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("int", {
      nullable: false,
      name: "created_user"
  })
  createdUser: number | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("int", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: number | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
  @OneToOne(() => Projects, projects => projects.projectId) 
  // specify inverse side as a second parameter
  projects: Projects;
  @OneToOne(() => UserEntity, user => user.id) 
  // specify inverse side as a second parameter
  users: UserEntity;
}
